import { client, handleClientMethod } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { ApiRequestBody } from "@onsemble/shared";

type InviteCustomerRequestBody = ApiRequestBody["inviteCustomer"];

export interface InviteCustomerRequest extends Omit<
  InviteCustomerRequestBody,
  "customerHistoryFile"
> {
  customerHistoryFile?: File;
}

export const useInviteCustomer = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: InviteCustomerRequest) => {
      const formData = new FormData();
      formData.append("firstName", data.firstName);
      formData.append("lastName", data.lastName);
      formData.append("email", data.email);
      formData.append("customerId", data.customerId || "");
      if (data.phone) {
        formData.append("phone", data.phone);
      }
      if (data.customerHistoryFile) {
        formData.append("customerHistoryFile", data.customerHistoryFile);
      }

      return await handleClientMethod(
        client.POST("/api/customers/invite", {
          body: formData as any,
        }),
      );
    },
    onSuccess: () => {
      // Invalidate customers query to refresh the list if needed
      queryClient.invalidateQueries({ queryKey: ["customers"] });
    },
  });
};
